module.exports = __webpack_public_path__ + "assets/img/5dccd30b3d69ce64148967232f8024c1.png";